export default __webpack_public_path__ + "e14e463b0b5067f4d391b2d7775142c4.ico";